import { Grid, styled } from "@mui/material";
import React from "react";
import Logo from "../../assets/logo.jpg";

export const MobileNavbarWrapper = styled(Grid)`
    background: #ec0000;
    h3{
        color: #fff;
    }
`;

function MobileNavbar({ text }) {
  return (
    <MobileNavbarWrapper container xs={12} alignItems={'center'} justifyContent={'space-between'} px={7} py={1}>
      <Grid item container xs={3} justifyContent={'flex-start'}>
        <img src={Logo} alt="" height={50} width={50} />
      </Grid>
      <Grid item xs={9} container justifyContent={'center'}>
        <h3 >{text}</h3>
      </Grid>
    </MobileNavbarWrapper>
  );
}

export default MobileNavbar;
